import { errors } from '@paychex/core';

import {
    set,
    unset,
    invoke,
    noop,
    mergeWith,
    get,
    isArray,
} from 'lodash';

import type { BatchModel, ModelUtils, Model, Batch } from './index';

import { ROLLBACK } from '../events';

const unionArrays = (lhs: any, rhs: any) => {
    if (isArray(lhs)) return lhs.concat(rhs);
}

export default function create(UPDATE: symbol): ModelUtils {

    function createBatch<T = any>(model: Model<T>): Batch<T> {

        function wrap(method: CallableFunction) {
            return function enqueue(...args: any[]) {
                if (model.disposed())
                    throw errors.error(`Cannot invoke method on disposed state.`, { method });
                mutations.push(function mutate() {
                    method(this, ...args);
                });
                return batch;
            };
        }

        function merge(target: any, path: any, ...objects: object[]) {
            set(target, path, mergeWith(get(target, path), ...objects, unionArrays));
        }

        const mutations: VoidFunction[] = [];

        const batch = {
            commit,
            set: wrap(set),
            merge: wrap(merge),
            unset: wrap(unset),
            invoke: wrap(invoke),
        };

        function commit() {
            let mutation;
            const promise = Promise.resolve();
            const snapshot = JSON.parse(JSON.stringify(model.snapshot()));
            while (/* eslint "no-cond-assign": 0 */ mutation = mutations.shift())
                promise.then(mutation.bind(snapshot));
            return promise
                .then(() => model.fire(UPDATE, snapshot))
                .then(() => model.snapshot())
                .catch(reason => {
                    model.fire(ROLLBACK, reason).catch(noop);
                    throw reason; // propagate to caller
                });
        }

        return batch;

    }

    return {

        withBatch<T = any>(model: Model<T>): BatchModel<T> {
            return {
                ...model,
                batch() {
                    return createBatch(model);
                },
            };
        }

    };

}
